export const standartsModule = 'standarts'
